module.exports = __webpack_public_path__ + "public/images/stand-logo.728ed7ac310510a18916ba23796ef77b.png";